import { useUserContext } from 'App/contexts/UserContext';
import { useAlertCenterAccess } from 'App/utils/hooks/useIsPermitted';
import * as R from 'ramda';
import React, { useEffect, useState } from 'react';
import { getAlertUsers } from 'App/services/AlertService';
import AlertsCenterIcon from 'App/components/AlertsCenter/AlertsCenterIcon/AlertsCenterIcon';
import useIsMounted from 'App/hooks/useIsMounted';

const propTypes = {};

const defaultProps = {};

function AlertsCenterHeader() {
    const hasAlertCenterAccess = useAlertCenterAccess();
    const user = useUserContext();
    const [alertUser, setAlertUser] = useState();
    const isMounted = useIsMounted();

    const userId = R.prop('id', user);

    useEffect(() => {
        if (hasAlertCenterAccess) {
            getAlertUsers().then((data) => {
                const users = R.compose(R.find(R.propEq(userId, 'userId')), R.values)(data);
                if (isMounted()) {
                    setAlertUser(users);
                }
            });
        }
    }, [hasAlertCenterAccess, userId, isMounted]);

    if (!hasAlertCenterAccess || R.isNil(alertUser)) {
        return null;
    }

    return <AlertsCenterIcon />;
}

AlertsCenterHeader.propTypes = propTypes;
AlertsCenterHeader.defaultProps = defaultProps;

export default AlertsCenterHeader;
